module.exports = __webpack_public_path__ + "static/media/co_bonohasta200.f7a3cd52.png";